var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var PersonIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 70,
    glyphHeight: 59
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65088 58.8193C13.3315 50.9714 23.7832 46.1643 35.4368 46.1643C47.0903 46.1643 57.542 50.9714 65.2227 58.8193C67.0615 56.646 68.667 54.2683 70 51.7258C64.6653 46.5386 58.1653 42.5469 50.8801 40.3208C55.4714 36.147 58.3933 30.0947 58.3933 23.2078C58.3933 10.4773 48.1672 0.251221 35.4368 0.251221C22.7063 0.251221 12.4802 10.4773 12.4802 23.2078C12.4802 29.886 15.4021 35.9382 19.9934 40.3208C12.7085 42.749 6.2085 46.5508 0.873779 51.7263C2.20679 54.2688 3.81201 56.646 5.65088 58.8193ZM35.4368 37.8164C43.5759 37.8164 50.0454 31.3469 50.0454 23.2078C50.0454 15.0686 43.5759 8.59912 35.4368 8.59912C27.2976 8.59912 20.8281 15.0686 20.8281 23.2078C20.8281 31.3469 27.2976 37.8164 35.4368 37.8164Z"
  }));
};
export var PersonIconGlyph = function (props) {
  return React.createElement(PersonIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};